import React, { useState } from 'react';
import { Dialog } from '@reach/dialog';

import ModalFAQs from '../components/ModalFAQs';
import LinkFAQ from '../components/LinkFAQ';

import Panel from './Panel';

import { colors } from '../config';

import { useGlobalData } from '../../store';
import { Card, Personal, Refresh } from './icons';
import { getCurrencySymbol, getCurrencyName, capitalize, getNumberWithDots } from '../helpers';

const Selection = () => {
  const [modal, setModal] = useState(false);
  const { globalData } = useGlobalData();

  const getImage = prestamo => {
    let image;

    switch (prestamo) {
      // case 'automotor':
      //   image = require('../../assets/prestamo-automotor.png');
      //   break;
      // case 'hipotecario':
      //   image = require('../../assets/prestamo-hipotecario.png');
      //   break;
      case 'amortizable':
        image = require('../../assets/panel-image-amortizable.jpg');
        break;
      case 'sobregiro':
        image = require('../../assets/panel-image-sobregiro.jpg');
        break;
      case 'tarjeta':
        image = require('../../assets/panel-image-tarjeta.jpg');
        break;
      default:
        image = require('../../assets/panel-image.jpg');
        break;
    }

    return image;
  };

  const getEyebrow = prestamo => {
    let text;

    switch (prestamo) {
      case 'hipotecario':
      case 'automotor':
        text = 'Requiere documentación';
        break;
      default:
        text = '100% Online';
        break;
    }

    return text;
  };

  const getIcon = prestamo => {
    let icon;

    switch (prestamo) {
      // case 'automotor':
      //   icon = <Car />;
      //   break;
      // case 'hipotecario':
      //   icon = <Home />;
      //   break;
      case 'sobregiro':
        icon = <Refresh />;
        break;
      case 'tarjeta':
        icon = <Card />;
        break;
      default:
        icon = <Personal />;
        break;
    }

    return icon;
  };

  const getTitle = prestamo => {
    let title;

    switch (prestamo) {
      case 'tarjeta':
        title = 'en tarjeta de crédito';
        break;
      case 'sobregiro':
        title = 'sobregiro en cuenta';
        break;
      case 'amortizable':
        title = 'amortizable';
        break;
      default:
        title = 'personal';
        break;
    }

    return title;
  };

  const getItems = prestamo => {
    let items;

    switch (prestamo) {
      case 'automotor':
        items = [
          {
            label: 'Monto',
            value:
              globalData.monto > 0
                ? `${getCurrencySymbol(globalData.moneda)} ${getNumberWithDots(globalData.monto) ||
                    0}`
                : '-',
          },
          { label: 'Moneda', value: getCurrencyName(globalData.moneda) || '-' },
          {
            label: 'Valor del auto',
            value: globalData.valor_auto ? `${getNumberWithDots(globalData.valor_auto) || 0}` : '-',
          },
          { label: 'Plazo', value: `${globalData.plazo} ${globalData.plazo > 0 ? 'años' : ''}` },
          { label: 'Marca', value: globalData.marca || '-' },
          { label: 'Modelo', value: globalData.modelo || '-' },
          { label: 'Condición', value: capitalize(globalData.condicion) || '-' },
        ];
        break;
      case 'hipotecario':
        items = [
          {
            label: 'Monto',
            value:
              globalData.monto > 0
                ? `${getCurrencySymbol(globalData.moneda)} ${getNumberWithDots(globalData.monto) ||
                    0}`
                : '-',
          },
          { label: 'Moneda', value: getCurrencyName(globalData.moneda) || '-' },
          {
            label: 'Valor propiedad',
            value: globalData.valor_propiedad
              ? `${getNumberWithDots(globalData.valor_propiedad) || 0}`
              : '-',
          },
          { label: 'Plazo', value: `${globalData.plazo} ${globalData.plazo > 0 ? 'años' : ''}` },
          { label: 'Destino', value: globalData.destino || '-' },
        ];
        break;
      default:
        items = [
          {
            label: 'Monto',
            value: globalData.monto
              ? `${getCurrencySymbol(globalData.moneda)} ${getNumberWithDots(globalData.monto)}`
              : '-',
          },
          {
            label: 'Moneda',
            value: getCurrencyName(globalData.moneda),
          },
          {
            label: 'Plazo',
            value: `${globalData.plazo} ${globalData.plazo > 0 ? 'meses' : ''}`,
          },
          {
            label: 'Destino',
            value:
              !globalData.destino || globalData.destino === '-' ? 'Consumo' : globalData.destino,
          },
        ];
        break;
    }

    return items;
  };

  return (
    <div className="selection">
      <Panel
        title={`Préstamo ${getTitle(globalData.title || globalData.prestamo)}`}
        image={getImage(globalData.title || globalData.prestamo)}
        icon={getIcon(globalData.title || globalData.prestamo)}
        eyebrow={getEyebrow(globalData.prestamo)}
        variant={globalData.prestamo}
        items={getItems(globalData.prestamo)}
      />

      <h2>
        <span>¿Cómo funciona?</span>
      </h2>

      <p className="copy">
        Tené en cuenta que estas opciones surgen de lo que simulaste, por lo que tu oferta final
        puede cambiar cuando analicemos tus datos
      </p>

      <hr />

      <div>
        <LinkFAQ onClick={() => setModal(true)} />
      </div>

      <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Preguntas Frecuentes">
        <ModalFAQs onDismiss={() => setModal(false)} defaultTab={1} />
      </Dialog>

      <style jsx>{`
        .selection {
          float: right;
          max-width: 332px;
          padding-top: 32px;
        }

        h2 {
          font-family: ${colors.baseFontDisplay};
          font-weight: 700;
          font-size: 22px;
          margin-top: 48px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          line-height: 1.25;
        }

        p {
          margin: 0;
        }

        .copy {
          font-size: 16px;
          line-height: 1.5;
          color: #56504c;
        }

        h2 > span:first-child {
          margin-right: 8px;
        }

        hr {
          height: 1px;
          background-color: #efe9e5;
          border: 0;
          margin-bottom: 28px;
          margin-top: 28px;
        }
      `}</style>
    </div>
  );
};

export default Selection;
